import type { NativeFederationResult } from '@angular-architects/native-federation';

let federationInstance: NativeFederationResult | null = null;

/** Clé globale sous laquelle l'instance est publiée pour les remotes qui ont besoin de charger d'autres remotes (ex. mecha-app-builder). */
export const MECHA_FEDERATION_GLOBAL_KEY = '__mechaFederation';

export function setFederation(federation: NativeFederationResult): void {
  federationInstance = federation;
  (globalThis as any)[MECHA_FEDERATION_GLOBAL_KEY] = federation;
}

export function getFederation(): NativeFederationResult | null {
  return federationInstance;
}

/**
 * Charge un module exposé par une remote via le `loadRemoteModule` renvoyé par `initFederation`
 * (le `loadRemoteModule` top-level de l'adapter est déprécié).
 */
export function loadRemoteModule<T = any>(remoteName: string, exposedModule: string): Promise<T> {
  if (!federationInstance) {
    return Promise.reject(new Error('Federation non initialisée : initFederation doit être appelé avant loadRemoteModule'));
  }

  return federationInstance.loadRemoteModule(remoteName, exposedModule) as Promise<T>;
}
